<template>
    <ModalComponent
        name="gastos-de-envio"
        title="Configurar envío"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="permitir_envio" v-model="lista_abonados.permitir_envio_a_domicilio"/>
                    <label class="custom-control-label pt-1 ml-3 mb-3" for="permitir_envio">Permitir envío a domicilio</label>
                </div>
                <div class="col-12" v-if="lista_abonados.permitir_envio_a_domicilio">
                    <label for="gastos_envio" class="ml-1">Introduce el gasto de envío</label>
                    <input type="number" id="gastos_envio" class="form-control" placeholder="Introduce el gasto de envío" step="0.01" v-model="lista_abonados.precio_envio_a_domicilio"/>
                </div>
                <div class="col-12 text-right mt-3">
                    <Button type="submit" name="button" :disabled="loading">GUARDAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['lista_abonados'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'gastos-de-envio', borrado);
            },
            editar() {
                this.loading = true;

                const params = {
                    filters : {},
                    lista_id: this.lista_abonados.id,
                    permitir_envio_a_domicilio: this.lista_abonados.permitir_envio_a_domicilio,
                    precio_envio_a_domicilio: this.lista_abonados.precio_envio_a_domicilio
                }

                this.$store.dispatch(this.config.getVuexAlias('back.lista.editar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editar();
                }
            },
        },
        components: {
            ModalComponent
        }
    }
</script>
